module.exports = __webpack_public_path__ + "assets/img/b1a3e83a80a924fab7875a46664525a0.svg";